export default __webpack_public_path__ + "static/media/eye-strain.d631c900.svg";